import Button from "@mui/material/Button";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import TooltipWithClickAway from "../../../components/terminalPicker/TooltipWithClickAway";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  InitAllShortageFormValue,
  ShortageEntryNBSchema,
} from "../../../schema/dsException";
import AppState from "./../../../AppState";
import { usePackageMaster } from "../../../@hooks/usePackageMaster";
import { useCommodityMaster } from "../../../@hooks/useCommodityMaster";
import Loader from "./../../../components/loader/loader";
import { PopoutNotification } from "./../../../AppState/popoutNotification";
import NOTIFICATION_TYPE from "./../../../AppState/NotificationType";
import { compareObjects } from "./../../../helpers";
import { IDeliveredShort } from "../../../models/dsException";
import { isFormValueChanged } from "../../../AppState/isFormValueChanged";
import UploadDocument from "../../../components/uploadDocument/uploadDocument";
import { EShortageInvestigationStatus, XL_GRID_PROPS, EUploadKey } from "../../../constants";
import { GetDeliveredShortAPI } from "../../../API/getDeliveredShort";
import DsInvestigation from "./dsInvestigation";
import { UpdateDSEntryAPI } from "../../../API/updateDSEntry";
import { CommodityField, FormField } from "../../../components/shared/form";
import PackageField from "../../../components/shared/form/packageField";
import PageHeaderWithBack from "../../../components/PageHeaderWithBack";
import { useDateTimeFormatter } from "../../../@hooks/useDateTimeFormatter";
import { useAccordionExpand } from "../../../@hooks/useAccordionExpand";
import ClearedInstructionDetails from "../../../components/cleared/clearedInstructionDetails";
function renderDisabledField(
  label: string,
  value: any,
  name: string,
  gridMd: number = 3
) {
  return (
    <FormField
     
      gridProps={{ md: gridMd, xs: 12 }}
      id={name}
      label={label}
      value={value}
      disabled
    />
  );
}

function DeliveredShortException() {
  const dispatch = useDispatch();
  const { osdNumber } = useParams();

  const [isSubmitted, setIsSubmitted] = React.useState<boolean>(false);

  const [formFieldsDisabled, setFormFieldsDisabled] = React.useState<boolean>(
    Boolean(osdNumber)
  );

  const [osdDetails, setOsdDetails] = React.useState<IDeliveredShort>();
  const [updatedDateTime, setUpdatedDateTime] = React.useState<string>("");
  const formatShortageDateTime = useDateTimeFormatter(setUpdatedDateTime);

  const [investigationStatus, setInvestigationStatus] =
    React.useState<number>();
  const [editFormValueChanged, setEditFormValueChanged] =
    React.useState<boolean>(false);

  const packageCodeOptions = useSelector(
    (state: AppState) => state.packageOptionMasterData
  );
  const { loadPackageOptions } = usePackageMaster();
  const { loadCommodityOptions } = useCommodityMaster();
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  // get master from API for commodity code and package code
  const [expanded, setExpanded] = React.useState<string[]>(["panel1"]); // handle expand page using "expanded" variable

  // set Initial value of All Shortage entry form
  const [isEditFormValuePatched, setIsEditFormValuePatched] =
    React.useState<string>("");
  const initValue: any = InitAllShortageFormValue;

  const [initialFormValue, setInitialFormValue] =
    React.useState<any>(initValue);

  const isCleared = osdDetails?.clearedInstructionDetails?.cleared;
  // Initialize All shortage entry form using formik and pass validation schema and initial values
  // handle all form event and submit form using formik

  const {
    values,
    errors,
    handleChange,
    handleBlur,
    touched,
    handleSubmit,
    setFieldValue,
    resetForm,
    isSubmitting,
  } = useFormik({
    validationSchema: ShortageEntryNBSchema,
    validateOnChange: false,
    initialValues: initValue,

    // Submit the form if all form fields are validated
    onSubmit: (values) => {
      if (!editFormValueChanged && osdNumber) {
        return;
      }
      setPageLoading(true);
      const reqInput = {
        ...values,
        weight: Number.parseInt(values.weight),
        pieces: Number.parseInt(values.pieces),
        commodity: values.commodity?.trim(),
        description: values.description?.trim(),
        itemCartonModelSerialNumber: values.itemCartonModelSerialNumber?.trim(),
      };

      const handleResponse = (response: IDeliveredShort) => {
        setPageLoading(false);
        setIsSubmitted(true);
        setExpanded(["panel1", "panel2"]);
        setFormFieldsDisabled(true);
        viewAllShortageEntry(response.osdNumber ?? osdNumber);
        dispatch(
          PopoutNotification(
            NOTIFICATION_TYPE.SUCCESS,
            `OS&D # ${osdNumber} has been updated successfully`,
            Date.now().toString()
          )
        );
      };

      const handleError = (err: any) => {
        setPageLoading(false);
        dispatch(
          PopoutNotification(
            NOTIFICATION_TYPE.ERROR,
            err || `Delivered shortage entry updating failed`,
            Date.now().toString()
          )
        );
      };
      UpdateDSEntryAPI(reqInput, osdNumber)
        .then(handleResponse)
        .catch(handleError);
    },
  });

  // get Commodity and package code option master
  const getMasters = (ParamString: string) => {
    if (ParamString === "packageCode") {
      loadPackageOptions();
    } else if (ParamString === "commodity") {
      loadCommodityOptions();
    }
  };


  const enableEditing = () => {
    setFormFieldsDisabled(false);
  };

  // set form value on exception type changed
  const reset = () => {
    resetForm();
    patchEditFormValues(initialFormValue);
  };

      // Handle accordion expand (now using custom hook)
    const handleAccordionChange = useAccordionExpand({
      osdNumber,
      expanded,
      setExpanded,
      setFormFieldsDisabled,
      reset,
    });

  const patchEditFormValues = (allShortage: any) => {
    const trimOrDefault = (value: any) =>
      typeof value === "string" ? value.trim() ?? "" : value;

    // Set form field values
    Object.keys(InitAllShortageFormValue).forEach((field) => {
      setFieldValue(field, trimOrDefault(allShortage[field]));
    });

    // Indicate that form values have been patched
    setIsEditFormValuePatched(Date.now().toString());
  };
  const viewAllShortageEntry = (osdId?: number | string) => {
    if (osdId) {
      // get AS entry and set form fields
      setPageLoading(true);
      GetDeliveredShortAPI(osdNumber ?? osdId ?? "")
        .then((allShortage: IDeliveredShort) => {
          formatShortageDateTime(allShortage);

          if (allShortage?.weight === 0) {
            allShortage["weight"] = undefined;
          }
          if (allShortage?.pieces === 0) {
            allShortage["pieces"] = undefined;
          }
          setOsdDetails(allShortage);
          setInvestigationStatus(
            allShortage?.investigationStatus ??
              EShortageInvestigationStatus.exceptionEntry
          );
          patchEditFormValues(allShortage);
          setPageLoading(false);
        })
        .catch((err: any) => {
          console.error(err);
           dispatch(
             PopoutNotification(
               NOTIFICATION_TYPE.ERROR,
               typeof err === "string" ? err : `OS&D # ${osdNumber} not found`,
               Date.now().toString(),
             ),
           );
          setPageLoading(false);
        });
    }
  };


  const getHelperText = (
    field: keyof IDeliveredShort,
    condtion: boolean = true
  ) => {
    if (!!errors?.[field] && touched?.[field] && condtion) {
      return (errors?.[field] as string) ?? "";
    }
    return "";
  };

  const hasError = (
    fieldName: keyof IDeliveredShort,
    checkValues: boolean = true
  ) => {
    return Boolean(errors[fieldName] && touched[fieldName]) && checkValues;
  };

  useEffect(() => {
    if (osdDetails?.commodity) {
      setFieldValue("commodity", osdDetails?.commodity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [osdDetails?.commodity]);

  useEffect(() => {
    if (osdNumber && isEditFormValuePatched) {
      setInitialFormValue(values);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditFormValuePatched]);

  useEffect(() => {
    setEditFormValueChanged(!compareObjects(values, initialFormValue));
    dispatch(isFormValueChanged(!compareObjects(values, initialFormValue)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, initialFormValue]);

  useEffect(() => {
    dispatch(isFormValueChanged(false));
    if (osdNumber) {
      viewAllShortageEntry(osdNumber);
    }

    if (!packageCodeOptions?.length) {
      getMasters("packageCode");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isSubmitting) return;
    if (Object.keys(errors)?.length > 0) {
      document.getElementsByName(Object.keys(errors)[0])[0].focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitting]);

  return (
    <div className="bg-layout overage-entry">
      {/* header */}
      <PageHeaderWithBack
        osdNumber={osdNumber}
        proNumber={osdDetails?.proNumber}
        updatedDateTime={updatedDateTime}
        headingTitle="Delivered Short"
      />

      {/* body */}
      <div className="content-area">
        <Accordion
          className="accordion"
          expanded={expanded.includes("panel1")}
          onChange={handleAccordionChange("panel1")}
        >
          <AccordionSummary
            className="header"
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              className={
                isSubmitted || osdNumber
                  ? "queue-check queue-check-gc"
                  : "queue-check"
              }
            >
              1
            </Typography>
            <Typography className="accordion-header">
              Delivered Short Exception
            </Typography>
          </AccordionSummary>
          <form action="" onSubmit={handleSubmit}>
            <AccordionDetails className="accordion-container">
              <div id="overageEntry">
                <Grid container spacing={2} className="filter-margin">
                  {renderDisabledField("Type", osdDetails?.type, "type")}
                  {renderDisabledField(
                    "Reporting Terminal",
                    osdDetails?.reporting,
                    "reporting",
                  )}
                  {renderDisabledField(
                    "Reporting Terminal",
                    osdDetails?.reporting,
                    "reporting",
                  )}
                </Grid>
                <div>
                  <Grid container spacing={2} className="filter-margin">
                    {renderDisabledField(
                      "PRO#",
                      osdDetails?.proNumber,
                      "proNumber",
                    )}
                    {renderDisabledField(
                      "Origin Terminal",
                      osdDetails?.origin,
                      "origin",
                    )}
                    {renderDisabledField(
                      "Destination Terminal",
                      osdDetails?.destination,
                      "destination",
                    )}
                  </Grid>
                  <Grid container spacing={2} className="filter-margin">
                    {renderDisabledField(
                      "Last Trailer Number",
                      osdDetails?.trailer,
                      "trailer",
                    )}
                    {renderDisabledField(
                      "Last Manifest Number",
                      osdDetails?.lastManifest,
                      "lastManifest",
                    )}
                  </Grid>

                  <Grid container spacing={2} className="filter-margin">
                    {renderDisabledField(
                      "Shipper Account #",
                      osdDetails?.shipperAccount,
                      "shipperAccount",
                      3,
                    )}
                    {renderDisabledField(
                      "Shipper Name",
                      osdDetails?.shipper,
                      "shipper",
                      3,
                    )}
                    {renderDisabledField(
                      "Shipper Address",
                      osdDetails?.shipperAddress,
                      "shipperAddress",
                      6,
                    )}
                  </Grid>

                  <Grid container spacing={2} className="filter-margin">
                    {renderDisabledField(
                      "Shipper Zip",
                      osdDetails?.shipperZip,
                      "shipperZip",
                      3,
                    )}
                    {renderDisabledField(
                      "Shipper City",
                      osdDetails?.shipperCity,
                      "shipperCity",
                      3,
                    )}
                    {renderDisabledField(
                      "Shipper State",
                      osdDetails?.shipperState,
                      "shipperState",
                      3,
                    )}
                  </Grid>

                  <Grid container spacing={2} className="filter-margin">
                    {renderDisabledField(
                      "Consignee Account #",
                      osdDetails?.consigneeAccount,
                      "consigneeAccount",
                      3,
                    )}
                    {renderDisabledField(
                      "Consignee Name",
                      osdDetails?.consignee,
                      "consignee",
                      3,
                    )}
                    {renderDisabledField(
                      "Consignee Address",
                      osdDetails?.consigneeAddress,
                      "consigneeAddress",
                      6,
                    )}
                  </Grid>

                  <Grid container spacing={2} className="filter-margin">
                    {renderDisabledField(
                      "Consignee Zip",
                      osdDetails?.consigneeZip,
                      "consigneeZip",
                      3,
                    )}
                    {renderDisabledField(
                      "Consignee City",
                      osdDetails?.consigneeCity,
                      "consigneeCity",
                      3,
                    )}
                    {renderDisabledField(
                      "Consignee State",
                      osdDetails?.consigneeState,
                      "consigneeState",
                      3,
                    )}
                  </Grid>
                </div>

                <Grid container spacing={2} className="filter-margin">
                  <CommodityField
                    id="commodity"
                    label="Commodity"
                    key={values.commodity}
                    disabled={formFieldsDisabled}
                    value={values.commodity}
                    onChange={(_, value) =>
                      setFieldValue("commodity", value?.code ?? "")
                    }
                    placeholder="Enter commodity"
                    required
                    onBlur={handleBlur("commodity")}
                    error={touched.commodity && !!errors.commodity}
                    helperText={getHelperText("commodity", !values.commodity)}
                  />

                  <PackageField
                    formFieldsDisabled={formFieldsDisabled}
                    value={values?.package ?? ""}
                    handleChange={(event) => {
                      setFieldValue("package", event.target.value ?? "");
                    }}
                    handleBlur={handleBlur("package")}
                    error={getHelperText("package", !values.package)}
                    hasError={(field: string, condition) =>
                      !!touched[field] && condition
                    }
                  />

                  <FormField
                    id="pieces"
                    label="Total Pieces"
                    type="number"
                    required={true}
                    value={values.pieces}
                    placeholder="Enter Pieces"
                    data-testid="pieces"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={hasError("pieces")}
                    disabled={formFieldsDisabled}
                    helperText={getHelperText("pieces")}
                    maxLength={5}
                  />
                  <FormField
                    id="weight"
                    label="Weight"
                    data-testid="weight"
                    type="number"
                    required={true}
                    value={values.weight}
                    placeholder="Enter Weight"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={hasError("weight")}
                    disabled={formFieldsDisabled}
                    helperText={getHelperText("weight")}
                    maxLength={7}
                  />
                </Grid>

                <Grid container spacing={2} className="filter-margin">
                  <FormField
                    id="itemCartonModelSerialNumber"
                    required={true}
                    label=" Does the shipment have (Item#, Carton#, Model#, Serial#"
                    value={values.itemCartonModelSerialNumber}
                    placeholder="Enter Manifest Number"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={hasError("itemCartonModelSerialNumber")}
                    disabled={formFieldsDisabled}
                    helperText={String(
                      getHelperText("itemCartonModelSerialNumber"),
                    )}
                    maxLength={56}
                    gridProps={{ md: 4, xs: 12 }}
                  />
                  <Grid item md={8} xs={12}>
                    <FormControl className="radio-group value-range">
                      <FormLabel id="valueRangeLabel">
                        Value Range &nbsp;
                      </FormLabel>

                      <Grid container spacing={2}>
                        <Grid
                          item
                          {...XL_GRID_PROPS}
                          className="float-div form-content-start"
                        >
                          <FormGroup className="shift-left">
                            <RadioGroup
                              row
                              aria-labelledby="valueRange"
                              name="valueRange"
                              value={osdDetails?.valueRange}
                            >
                              <FormControlLabel
                                value="1"
                                disabled
                                control={<Radio />}
                                label="$0 - $250.00"
                                name="valueRange"
                                checked={osdDetails?.valueRange === "1"}
                              />
                              <FormControlLabel
                                value="2"
                                disabled
                                control={<Radio />}
                                label="$250.00 - $1,000.00"
                                name="valueRange"
                                checked={osdDetails?.valueRange === "2"}
                              />
                              <FormControlLabel
                                disabled
                                value="3"
                                control={<Radio />}
                                label="Greater than $1,000.00"
                                name="valueRange"
                                checked={osdDetails?.valueRange === "3"}
                              />
                              <TooltipWithClickAway
                                tooltipText="If value needs to be edited e-mail catkinson@saia.com"
                                tooltipKey="tooltip1"
                              />
                            </RadioGroup>
                          </FormGroup>

                          {osdDetails?.valueRange === "3" && (
                            <FormGroup className="no-wrap">
                              <FormGroup className="form-row shift-left">
                                <TextField
                                  autoComplete="off"
                                  className="justify-content disabled"
                                  value="$"
                                  variant="outlined"
                                  disabled
                                />
                                <TextField
                                  autoComplete="off"
                                  type="number"
                                  className="justify-content"
                                  placeholder="Enter Amount"
                                  variant="outlined"
                                  disabled
                                  name="value1k"
                                  value={osdDetails?.value1k}
                                />
                              </FormGroup>
                            </FormGroup>
                          )}
                        </Grid>
                      </Grid>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="filter-margin">
                  {renderDisabledField(
                    "Number of Shrink Wrapped Pallets",
                    osdDetails?.shrinkWrappedPalletCount,
                    "shrinkWrappedPalletCount",
                    4,
                  )}
                  <Grid item md={8} xs={12}>
                    <FormControl className="radio-group value-range">
                      <FormLabel id="wasOriginalShrinkwrapIntactLabel">
                        Was the Original Shrinkwrap Intact?
                      </FormLabel>
                      <Grid container spacing={2}>
                        <Grid
                          item
                          {...XL_GRID_PROPS}
                          className="float-div form-content-start"
                        >
                          <FormGroup className="shift-left">
                            <RadioGroup
                              row
                              aria-labelledby="wasOriginalShrinkwrapIntact"
                              name="wasOriginalShrinkwrapIntact"
                              value={osdDetails?.wasOriginalShrinkwrapIntact}
                            >
                              <FormControlLabel
                                value="Y"
                                disabled
                                control={<Radio />}
                                label="Yes"
                                name="wasOriginalShrinkwrapIntact"
                                checked={
                                  osdDetails?.wasOriginalShrinkwrapIntact ===
                                  "Y"
                                }
                              />
                              <FormControlLabel
                                value="N"
                                disabled
                                control={<Radio />}
                                label="No"
                                name="wasOriginalShrinkwrapIntact"
                                checked={
                                  osdDetails?.wasOriginalShrinkwrapIntact ===
                                  "N"
                                }
                              />
                            </RadioGroup>
                          </FormGroup>
                        </Grid>
                      </Grid>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={2} className="filter-margin">
                  <FormField
                    id="description"
                    required={true}
                    label="Additional Details"
                    value={values.description}
                    data-testid="description"
                    placeholder="Enter Additional Details"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={hasError("description")}
                    disabled={formFieldsDisabled}
                    helperText={(getHelperText("description") ?? "").toString()}
                    maxLength={56}
                    gridProps={XL_GRID_PROPS}
                  />
                </Grid>
              </div>
              {!isCleared && 
                <div className="btn-group-submit">
                  {Boolean(osdNumber) && !formFieldsDisabled && (
                    <>
                      <Button
                        type="button"
                        variant="contained"
                        className="clear-btn mr-0 ml"
                        onClick={() => reset()}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        data-testid="update-button"
                        className={
                          editFormValueChanged
                            ? "assign mr-0 ml"
                            : "disable-btn disable assign mr-0 ml"
                        }
                      >
                        Update
                      </Button>
                    </>
                  )}
                  {!osdNumber && !isSubmitted && (
                    <Button
                      type="submit"
                      variant="contained"
                      className={
                        isSubmitted ? "disable-btn disable entry ml" : "entry ml"
                      }
                    >
                      {values.valueRange === "3" ? "Submit & Send APB" : "Submit"}
                    </Button>
                  )}
                  {Boolean(osdNumber) &&
                    formFieldsDisabled &&
                    investigationStatus !==
                      EShortageInvestigationStatus.complete && (
                      <Button
                        // type="submit"
                        data-testid="testid-ov-edit-button"
                        variant="contained"
                        className="assign mr-0 ml"
                        onClick={enableEditing}
                      >
                        Edit
                      </Button>
                    )}
                </div>
              }
              
            </AccordionDetails>
          </form>
        </Accordion>

        <Accordion
          className="accordion"
          expanded={expanded.includes("panel2")}
          onChange={handleAccordionChange("panel2")}
        >
          <AccordionSummary
            className="header"
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <Typography
              className={
                investigationStatus === EShortageInvestigationStatus.complete || isCleared
                  ? "queue-check queue-check-gc"
                  : "queue-check"
              }
            >
              2
            </Typography>
            <Typography className="accordion-header">
              Delivered Short Investigation &nbsp;&nbsp;&nbsp;
            </Typography>
            <Typography className="header-notice-2 note-scroll">
              <div className="animate">
                Do not request camera check prior to reaching that stage of the
                investigation
              </div>
            </Typography>
          </AccordionSummary>

          <DsInvestigation
            setInvestigationStatus={setInvestigationStatus}
            isFormEditMode={Boolean(osdNumber)}
            osdDetails={osdDetails}
            isCleared={isCleared}
          />
        </Accordion>
        <Accordion
          className="accordion"
          expanded={expanded.includes("panel3")}
          onChange={handleAccordionChange("panel3")}
        >
          <AccordionSummary
            className="header"
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <Typography className={isCleared? "queue-check queue-check-gc" : "queue-check"}>3</Typography>
            <Typography className="accordion-header">
              {isCleared
                ? "Cleared Instruction Details"
                : "Upload Documents"}
            </Typography>
          </AccordionSummary>

          {isCleared ? (
            <ClearedInstructionDetails
              clearedInstructionDetails={osdDetails.clearedInstructionDetails}
            />
          ) : (
            <UploadDocument
              key={expanded.toString() || "upload-document"}
              osdNumber={Number.parseInt(osdNumber!)}
              uploadKey={EUploadKey.pro}
            />
          )}
        </Accordion>
      </div>
      <Loader pageLoader={pageLoading}></Loader>
    </div>
  );
}

export default DeliveredShortException;
